import React, { useMemo, useContext } from 'react';
import classnames from 'classnames';
import Page from '../../../components/page';
import ErrorBoundary from '../../../components/error-boundary';
import style from '../../grid-page.module.less';
import categoryStyle from './style.module.less';
import { FormattedMessage } from 'react-intl';
import ReportingCategoryGrid from './grid';
import ReportingCategoryContextProvider, { ReportingCategoryContext } from './context';
import { PagingContextProvider } from '../../../contexts/paging-context';
import PagingControlWrapper from '../PagingControlWrapper';
import { GridHeaderWithOverflow } from '../../../components/grid-header/grid-header-with-overflow';
import AddReportingCategoryPopover from './add-reporting-category-button';
import messages from './messages';
import { UserSettings } from '../../../enums/user-settings/user-settings';
import { useUserSetting } from '../../../hooks/use-user-setting';
import HeaderRow from './header-row';

const label = <FormattedMessage {...messages.reportingCategoryGridLabel} />;
const headerId = 'reportingCategoryGridHeader';
const view = {
  id: headerId,
  buttons: [<AddReportingCategoryPopover key={headerId} />],
  label,
};

const ReportingCategoriesPage = () => {
  const { totalRecords = 0 } = useContext(ReportingCategoryContext);

  return (
    <Page>
      <div className={style['grid-page']}>
        <div className={style['main-content']}>
          <div className={style['grid-header']}>
            <GridHeaderWithOverflow ignoreCustomOverflow view={view} />
          </div>
          <div className={style['edit-grid-wrap']} />
          <div className={style['grid-content']}>
            <div className={classnames(style['grid-and-footer'], style['no-sidebar'])}>
              <div className={categoryStyle.grid}>
                <ErrorBoundary errorMessageId='reportingCategoriesGrid'>
                  <HeaderRow />
                  <ReportingCategoryGrid />
                </ErrorBoundary>
              </div>
              <div className={[style['paging-footer']]}>
                <PagingControlWrapper totalRecords={totalRecords} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default () => {
  const userSetting = useUserSetting(UserSettings.reportingCategoriesGridPageSize.settingName);
  const userPageSize = useMemo(() => parseInt(userSetting || 250, 10), [userSetting]);
  return (
    <PagingContextProvider page={1} pageSize={userPageSize}>
      <ReportingCategoryContextProvider>
        <ReportingCategoriesPage />
      </ReportingCategoryContextProvider>
    </PagingContextProvider>
  );
};
